import StudentUploadSubmissionsDialog from 'components/ViewAssignment/StudentUploadSubmissionsDialog';
import { useApp } from 'contexts/app';
import { useViewport } from 'contexts/viewport';
import ErrorPage from 'pages/Error/404';
import { PageContext } from 'pages/StudentViewAssignment/PageProvider';
import Desktop from 'pages/StudentViewAssignment/desktop';
import Mobile from 'pages/StudentViewAssignment/mobile';
import Tablet from 'pages/StudentViewAssignment/tablet';
import { useContext } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Loading } from 'shell/components';

const PageLayout = () => {
    const { isLoading, assignments, currentAssignmentId, currentAssignment, batch, feedback } = useApp();
    const history = useHistory();
    const params = useParams();
    const { device } = useViewport();

    const { uploadAssignmentsDialog, setUploadAssignmentsDialog, createSubmissions } = useContext(PageContext);

    const handleClickBack = () => {
        history.push('/assignments');
    };

    const handleClickGetFeedback = () => {
        setUploadAssignmentsDialog({ open: true });
    };

    const handleClickViewFeedback = (feedback) => {
        history.push(`/assignments/${currentAssignmentId}/feedback/${feedback.id}`);
    };

    const props = {
        assignment: currentAssignment,
        batch,
        feedback,
        onClickBack: handleClickBack,
        onClickGetFeedback: handleClickGetFeedback,
        onClickViewFeedback: handleClickViewFeedback,
    };

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    if (isLoading || currentAssignmentId !== params.id || !batch || !feedback) return <Loading />;

    if (assignments && !currentAssignment) return <ErrorPage />;

    return (
        <>
            {renderResponsiveLayout(device)}
            <StudentUploadSubmissionsDialog
                open={uploadAssignmentsDialog.open}
                assignment={currentAssignment}
                onClose={() => setUploadAssignmentsDialog({ open: false })}
                onClick={createSubmissions}
            />
        </>
    );
};

export default PageLayout;
